/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer__Auctions__Item_1Inputs */

const en_footer__auctions__item_1 = /** @type {(inputs: Footer__Auctions__Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Products`)
};

/**
* | output |
* | --- |
* | "All Products" |
*
* @param {Footer__Auctions__Item_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer__auctions__item_1 = /** @type {((inputs?: Footer__Auctions__Item_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer__Auctions__Item_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer__auctions__item_1(inputs)
});